<template>
    <BasePageSrpPdf>
        <template v-slot:slot_general_info="slotprop_slot_general_info">
            <ComponentGeneralInfo 
            v-bind:prop_submission="slotprop_slot_general_info.submission"/>
        </template>
        <template v-slot:slot_media>
            <h4>No Media</h4>
        </template>
        <template v-slot:slot_services_summaries="slotprop_slot_services_summaries">
            <v-row id="ID-ROW-pdf-page-3">
                <v-col cols="4">
                    <ComponentSummary6 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary3 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                </v-col>
                <v-col cols="4">
                    <ComponentSummary1 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary4 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                </v-col>
                <v-col cols="4">
                    <ComponentSummary2 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary5 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                </v-col>
            </v-row>
        </template>
    </BasePageSrpPdf>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################

//GENERIC COMPONENTS

//MODULE COMPONENTS
import ComponentGeneralInfo from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentGeneralInfo';
import ComponentSummary1 from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentSummary1';
import ComponentSummary2 from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentSummary2';
import ComponentSummary3 from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentSummary3';
import ComponentSummary4 from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentSummary4';
import ComponentSummary5 from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentSummary5';
import ComponentSummary6 from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentSummary6';

//BASE_PAGE
import BasePageSrpPdf from '@/views/base_pages/BasePageSrpPdf';

//########################################
//CONST AND VARS
//########################################

//########################################
//MAIN
//########################################

export default {
    name: 'ModuleNhmisdqaodkPageSrpPdf',

    components: {
        //BASE PAGE
        BasePageSrpPdf,

        //GENERIC COMPONENTS

        //MODULE COMPONENTS
        ComponentGeneralInfo,
        ComponentSummary1,
        ComponentSummary2,
        ComponentSummary3,
        ComponentSummary4,
        ComponentSummary5,
        ComponentSummary6,

    }
};
</script>
